module.exports = __webpack_public_path__ + "images/vangent40cd25293d8b65c23d5094fa830b3be3.png";